<div class="styling-menu">
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.LEFT_ALIGNED) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_align_left' | i18next }}"
    >
        <i
            class="align-left-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.LEFT_ALIGNED) }"
            (click)="applyStyle(hamStyles.LEFT_ALIGNED)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.CENTER_ALIGNED) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_align_center' | i18next }}"
    >
        <i
            class="align-center-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.CENTER_ALIGNED) }"
            (click)="applyStyle(hamStyles.CENTER_ALIGNED)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.RIGHT_ALIGNED) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_align_right' | i18next }}"
    >
        <i
            class="align-right-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.RIGHT_ALIGNED) }"
            (click)="applyStyle(hamStyles.RIGHT_ALIGNED)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.BOLD) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_bold' | i18next }}"
    >
        <i
            class="bold-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.BOLD) }"
            (click)="applyStyle(hamStyles.BOLD)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.UNDERLINED) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_underlined' | i18next }}"
    >
        <i
            class="underlined-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.UNDERLINED) }"
            (click)="applyStyle(hamStyles.UNDERLINED)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.ITALIC) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_italic' | i18next }}"
    >
        <i
            class="italic-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.ITALIC) }"
            (click)="applyStyle(hamStyles.ITALIC)"
        ></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.PERCENTAGE) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_percentage' | i18next }}"
    >
        <i
            class="percentage-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.PERCENTAGE) }"
            (click)="applyStyle(hamStyles.PERCENTAGE)"
        ></i>
    </span>
    <span class="ham-icon" hamTooltip="{{ 'aumico_components_ham_styling_menu_less_decimals' | i18next }}">
        <i class="less-digits-icon style-icon" (click)="applyStyle(hamStyles.DECREASE_DECIMALS)"></i>
    </span>
    <span class="ham-icon" hamTooltip="{{ 'aumico_components_ham_styling_menu_more_decimals' | i18next }}">
        <i class="more-digits-icon style-icon" (click)="applyStyle(hamStyles.INCREASE_DECIMALS)"></i>
    </span>
    <span
        class="ham-icon"
        [ngClass]="{ active: isStyleActive(hamStyles.FLIP_SIGN) }"
        hamTooltip="{{ 'aumico_components_ham_styling_menu_flip_sign' | i18next }}"
    >
        <i
            class="positive-value-icon style-icon"
            [ngClass]="{ active: isStyleActive(hamStyles.FLIP_SIGN) }"
            (click)="applyStyle(hamStyles.FLIP_SIGN)"
        ></i>
    </span>
</div>
